import { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  // Read localStorage synchronously so the very first render already knows auth state.
  // This prevents the brief false→true flip that caused a redirect on browser refresh.
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !!localStorage.getItem("tokenString")
  );

  // ✅ Save token to localStorage
  const login = (token) => {
    localStorage.setItem("tokenString", token);
    setIsAuthenticated(true);
  };

  // ✅ Remove session on logout
  const logout = () => {
    localStorage.removeItem("tokenString");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
